<template>
  <div>
    <div class="app-container">
      <el-row :gutter="20">
          <el-form :model="formInline" ref="queryForm" size="small" :inline="true" >
            <el-form-item>
              <span>问题分类：</span>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="formInline.type" placeholder="请选择">
                <el-option
                    v-for="item in type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span>错误级别：</span>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="formInline.level" placeholder="请选择">
                <el-option
                    v-for="item in level"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span>错误状态：</span>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="formInline.is_fixed" placeholder="请选择">
                <el-option
                    v-for="item in is_fixed"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span>平台：</span>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="formInline.platform" placeholder="请选择">
                <el-option
                    v-for="item in platform"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-download" size="mini" @click="exportExcel">导出</el-button>
            </el-form-item>
          </el-form>
      </el-row>
      <el-table v-loading="loading"
                ref="multipleTable"
                :data="tableList" border
                style="width: 100%"
                :row-key="getRowKeys"
                @selection-change="handleSelectionChange">
        <el-table-column
            type="selection"
            :reserve-selection="true">
        </el-table-column>
        <el-table-column label="标题" prop="title"  >
          <template slot-scope="scope">
            <div>
              <a style="cursor:pointer;color: #4C90FF"  @click="viewURL(scope.row)">{{scope.row.title}}</a>
              <div style="color: #888; font-size: 12px">
                    <span style="margin-right: 20px">
                      账号：{{ scope.row.author }}
                    </span>
                <span style="margin-right: 20px">
                      {{ scope.row.org_name }}({{scope.row.media_name}})
                    </span>
                <span style="margin-right: 20px">
                      发稿时间：{{scope.row.release_date}}
                    </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="检查结果" prop="result" width="400">
          <template slot-scope="scope">
            <div>
              <div>问题数量：{{scope.row.nums}}处</div>
              <div style="color: red">
                {{scope.row.classes[0].class}}：{{scope.row.classes[0].value}}
              </div>
              <div>
                <span v-if="scope.row.replaceWord !== ''" style="margin-right: 20px">订正：{{scope.row.replaceWord}}</span>
                <el-tag
                    size="mini"
                    :type="scope.row.error_level_show === '一般' ? 'warning' : 'danger'"
                    effect="dark">
                  {{ scope.row.error_level_show }}
                </el-tag>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="检测时间" align="center" prop="sensitive_time" width="300" />
<!--        <el-table-column label="状态" align="center" prop="status" width="200">-->
<!--          <template slot-scope="scope">-->
<!--            &lt;!&ndash; 根据 status 数组中的 value 查找对应的 label &ndash;&gt;-->
<!--            <span>{{ getStatusLabel(scope.row.status) }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="状态" align="center" prop="status" width="200">
          <template slot-scope="scope">
            <!-- 如果 is_fixed === 0，显示按钮 -->
            <el-button
                v-if="scope.row.is_fixed === 0 && hasUpdatePermission"
                type="primary"
                size="mini"
                @click="handleConfirmFix(scope.row)"
            >
              确认修正
            </el-button>
            <span v-if="scope.row.is_fixed === 0 && !hasUpdatePermission">未修正</span>
            <!-- 否则显示文本 -->
            <el-button
                v-if="scope.row.is_fixed === 1 && hasUpdatePermission"
                type="success"
                size="mini"
                @click="handleConfirmFix2(scope.row)"
            >
              已修正
            </el-button>
            <span v-if="scope.row.is_fixed === 1 && !hasUpdatePermission">已修正</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="width: 100%; margin: 10px 0">
        <el-pagination
            style="margin-top: 20px;text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[5, 10, 15]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import { JSEncrypt } from 'jsencrypt'
import CryptoJS from 'crypto-js'
import * as XLSX from 'xlsx';
import axios from "axios";

export default {
  name: 'Calibration',
  data() {
    return{
      search: '',
      loading: false,
      total: 0,
      tableList: [],
      multipleSelection: [],
      currentPage4: 1,
      pageSize: 10,
      formInline: {
        type: '',        // 问题分类，默认为空
        level: '-1',     // 错误级别，默认为全部错误
        is_fixed: '-1',     // 错误状态，默认为已确认
        status: '-1',
        platform: ''     // 平台，默认为空
      },
      type: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '错词',
          label: '错词'
        }, {
          value: '政治差错',
          label: '政治差错'
        }, {
          value: '禁用词',
          label: '禁用词'
        }, {
          value: '落马',
          label: '落马'
        }
      ],
      level: [
        {
          value: '-1',
          label: '全部错误'
        },
        {
          value: '2',
          label: '一般错误'
        }, {
          value: '1',
          label: '严重错误'
        }
      ],
      is_fixed: [
        {
          value: '-1',
          label: '全部'
        },
        {
          value: '0',
          label: '未修正'
        },
        {
        value: '1',
        label: '已修正'
      }],
      platform: [{
        value: '',
        label: '全部'
      }, {
        value: '514',
        label: '微博'
      }, {
        value: '515',
        label: '抖音'
      }, {
        value: '513',
        label: '微信'
      }, {
        value: '516',
        label: '头条'
      }, {
        value: '519',
        label: '外省'
      },{
        value: '518',
        label: '商媒'
      },{
        value: '517',
        label: '百家'
      },{
        value: '512',
        label: '主平台'
      }]
    }

  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    hasUpdatePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_wrong_update');
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true;
      this.$axios.get('/a2/third/dzrb/lists', {
        params: {
          page: this.currentPage4,
          pagesize: this.pageSize,
          error_level: this.formInline.level,
          status: this.formInline.status,
          is_fixed: this.formInline.is_fixed,
          class: this.formInline.type,
          org_source: this.formInline.platform
        }
      }).then(res => {
        this.tableList = res.data.data.list;
        this.total = res.data.data.total;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        console.error(error);
      });
    },
    viewURL(row) {
      window.open(row.url)
    },
    handleSizeChange(pageSize){
      this.pageSize = pageSize
      this.getList()
    },
    handleCurrentChange(pageNum) {
      this.currentPage4 = pageNum
      this.getList()
    },
    handleQuery() {
      this.currentPage4 = 1;
      this.getList()
    },
    handleConfirmFix(row) {
      // 示例：调用 API 更新状态
      this.$confirm('是否确定已修正', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post("/a2/third/dzrb/setFixed", {sensitive_id: row.id})
            .then(response => {
              this.$message({
                message: '修正成功',
                type: 'success'
              });
              // 更新表格数据
              row.is_fixed = 1; // 将状态更新为“已修正”
            })
      }).catch(error => {
            this.$message({
              type: 'info',
              message: '已取消修正'
            });
          });
    },
    handleConfirmFix2(row){
      this.$confirm('是否确定取消修正', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post("/a2/third/dzrb/setFixed", {
          sensitive_id: row.id,
          is_fixed: 0
        })
            .then(response => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              // 更新表格数据
              row.is_fixed = 0;
            })
      }).catch(error => {
        console.log(error)
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    getStatusLabel(value) {
      const statusItem =this.status.find(item => item.value === value.toString());
      return statusItem ? statusItem.label : '';
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    getRowKeys(row) {
      return row.id
    },
    exportExcel() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一条数据');
        return;
      }

      // Process the data for export
      const exportData = this.multipleSelection.map(item => {
        return {
          '标题': item.title,
          '链接': item.url,
          '账号': item.author,
          '平台': `${item.org_name}(${item.media_name})`,
          '发稿时间': item.release_date,
          // '问题数量': `${item.nums}处`,
          '问题分类': item.classes[0].class,
          '问题内容': item.classes[0].value,
          '订正词': item.replaceWord || '无',
          '错误级别': item.error_level_show,
          '检测时间': item.sensitive_time,
          '状态': item.is_fixed === 0 ? '未修正' : '已修正',
        };
      });

      // Create Excel workbook
      const XLSX = require('xlsx');
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '稿件差错');

      // Generate file and download
      const fileName = `稿件差错${new Date().toLocaleDateString()}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      this.$message.success('导出成功');
      this.$refs.multipleTable.clearSelection();
    },

    async signDataWithPrivateKey(base64PrivateKey, dataToSign) {
      // 1. Base64 解码私钥
      const privateKeyDer = Uint8Array.from(atob(base64PrivateKey), c => c.charCodeAt(0));

      // 2. 导入私钥（PKCS#8 格式）
      const privateKey = await window.crypto.subtle.importKey(
          'pkcs8',
          privateKeyDer.buffer,
          {
            name: 'RSASSA-PKCS1-v1_5',
            hash: { name: 'SHA-256' },
          },
          false,
          ['sign']
      );

      // 3. 签名数据
      const encoder = new TextEncoder();
      const data = encoder.encode(dataToSign);

      const signature = await window.crypto.subtle.sign(
          {
            name: 'RSASSA-PKCS1-v1_5',
          },
          privateKey,
          data
      );

      // 4. 返回 base64 签名
      return btoa(String.fromCharCode(...new Uint8Array(signature)));
    },



  }
}
</script>

<style scoped>

</style>